import type { RouteRecordRaw } from 'vue-router';

export default <RouteRecordRaw[]>[
  {
    path: 'tips',
    name: 'support-tips',
    redirect: '/support/tips/shortcuts',
    children: [
      {
        path: 'shortcuts',
        name: 'support-tips-shortcuts',
        component: () => import('./views/TipsShortcuts.view.vue'),
      },
    ],
  },
];
